export enum EFeatureType {
  OVERSIGHT = "OVERSIGHT",
  SOLAR_SIM = "SOLAR_SIM",
  BREEZE_LINK = "BREEZE_LINK",
}
